import React from 'react';
import { FormattedMessage as T } from '@/components/FormattedMessage';
import { FSelect } from '../Forms';

/**
 * Currency select field.
 * @returns {React.ReactNode}
 */
export function CurrencySelectList({
  // #ownProps
  items,
  name,
  placeholder = <T id={'select_currency_code'} />,
  ...props
}: any) {
  return (
    <FSelect
      name={name}
      items={items}
      textAccessor={'currency_code'}
      valueAccessor={'currency_code'}
      placeholder={placeholder}
      popoverProps={{ minimal: true, usePortal: false, inline: false }}
      {...props}
    />
  );
}
